import { Action } from "redux";

export enum GLOBAL_ACTION_TYPE {
  START_LOADING = "@Global/START_LOADING",
  END_LOADING = "@Global/END_LOADING",
  TOGGLE_SP_MENU = "@Global/TOGGLE_SP_MENU",
  SET_ERROR_MESSAGE = "@Global/SET_ERROR_MESSAGE",
  CLEAR_ERROR_MESSAGE = "@Global/CLEAR_ERROR_MESSAGE",
}

export interface GlobalLoadingAction extends Action {
}

export interface GlobalToggleSpMenuAction extends Action {
}

export type GlobalAction = GlobalLoadingAction | GlobalToggleSpMenuAction;

export const startLoadingAction = (): GlobalLoadingAction => ({
  type: GLOBAL_ACTION_TYPE.START_LOADING,
});

export const endLoadingAction = (): GlobalLoadingAction => ({
  type: GLOBAL_ACTION_TYPE.END_LOADING,
});

export const toggleSpMenuAction = (): GlobalToggleSpMenuAction => ({
  type: GLOBAL_ACTION_TYPE.TOGGLE_SP_MENU,
});